(function () {
  'use strict';

  // Only applies on mobile viewports
  if (window.matchMedia('(min-width: 990px)').matches) return;

  var BODY_CLASS = 'mobile-menu-open';

  // The Dawn menu uses <details id="Details-menu-drawer-container">
  // It gains the native [open] attribute when the drawer slides in.
  // We watch for that attribute change and mirror it as a body class
  // so the CSS fallback rule (body.mobile-menu-open) can hide the badge.

  function syncState() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;
    document.body.classList.toggle(BODY_CLASS, details.hasAttribute('open'));
  }

  function init() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;

    // MutationObserver watches the [open] attribute change on the <details>
    var observer = new MutationObserver(syncState);
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });

    // Also watch clicks on the summary (hamburger) in case the attribute
    // change fires before the observer registers
    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function () {
        // [open] reflects state *after* this click, so read it on next tick
        setTimeout(syncState, 0);
      });
    }

    // Sync on any focusin/keydown for keyboard-driven close (Escape)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setTimeout(syncState, 50);
    });

    // Initial sync in case the page loads with the menu already open
    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
